import HCheckArray from "@/src-refactor/modules/shared/components/refactor/helpers/check-have-value";
import { IPropertyCheckConflictResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-check-conflict";
import { prepareProperty } from "./list-property-adapter";

export const PropertyConflictListAdapter = (
  response: IPropertyCheckConflictResponse
) => {
  if (HCheckArray(response.data)) {
    return response.data.map(property => prepareProperty(property as any));
  } else {
    return [];
  }
};

// const prepareProperty = (item: PropertyCheckConflictData) => {
//   const title = prepareTitle(item);
//   const businessType = prepareBusinessType(item);
//   const pictures = preparePicture(item);
//   const { budget } = preparePrice(item);
//   const feature = prepareFeatures(item);

//   return {
//     id: item.id,
//     title,
//     conditionStatus: item.condition_status,
//     businessType,
//     pictures,
//     prices: budget,
//     feature: feature
//   } as ICardProperty;
// };

// const prepareTitle = (item: PropertyCheckConflictData) => {
//   return HPreparePropertyTitle({
//     cityName: item.city ?? "",
//     propertyType: item.realstate_type ?? "",
//     sectorName: item.sector ?? ""
//   });
// };

// const prepareBusinessType = (item: PropertyCheckConflictData) => {
//   return item.business_type;
// };

// const preparePicture = (item: PropertyCheckConflictData) => {
//   if (item.main_picture?.big) {
//     return [item.main_picture?.big];
//   }
//   return [];
// };

// const preparePrice = (item: PropertyCheckConflictData) => {
//   const budget = HPreparePrice({
//     alternativePrice: item?.alternate_price ?? "",
//     currencyAlternativePrice: item?.alternative_currency?.symbol ?? "",
//     currencyPrice: item.currency.symbol ?? "",
//     businessTypeId: O_BUSINESS_TYPE[item.business_type].id,
//     isProject: Boolean(item.project),
//     price: item.price,
//     maximumPrice: item.project?.maximum_price
//       ? item.project?.maximum_price.toString()
//       : "",
//     minimumPrice: item.project?.minimum_price
//       ? item.project?.minimum_price.toString()
//       : ""
//   });
//   return {
//     budget
//   };
// };

// const prepareFeatures = (item: PropertyCheckConflictData) => {
//   return prepareFeature({
//     bathrooms: item?.bathrooms ?? null,
//     bedrooms: item?.bedrooms ?? null,
//     floorLevel: item?.floor_level ?? null,
//     floorsTotal: item?.floors_total ?? null,
//     sqmLand: item?.sqm_land ?? null,
//     sqmConstruction: item?.sqm_construction ?? null,
//     pumps: item?.pumps ?? null,
//     parkingSpots: item?.parking_spots ?? null
//   });
// };
